import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-b from-[#00915a] via-[#006039] to-[#003d24] text-white shadow-[0_6px_20px_rgba(0,96,57,0.45),inset_0_2px_0_rgba(255,255,255,0.25),inset_0_-2px_4px_rgba(0,0,0,0.15)] hover:shadow-[0_8px_25px_rgba(0,96,57,0.55),inset_0_2px_0_rgba(255,255,255,0.3),inset_0_-2px_4px_rgba(0,0,0,0.15)] hover:from-[#00a066] hover:via-[#006d40] hover:to-[#004a2c] active:shadow-[0_2px_8px_rgba(0,96,57,0.3),inset_0_3px_6px_rgba(0,0,0,0.2)] border border-[#004d2e]/30",
        destructive:
          "bg-destructive text-destructive-foreground shadow-soft hover:bg-destructive/90",
        outline:
          "border-2 border-[#006039] bg-background text-[#006039] hover:bg-[#006039]/5",
        secondary:
          "bg-secondary text-secondary-foreground shadow-soft hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        zen: "bg-gradient-to-b from-[#00915a] via-[#006039] to-[#003d24] text-white shadow-[0_6px_20px_rgba(0,96,57,0.45),inset_0_2px_0_rgba(255,255,255,0.25),inset_0_-2px_4px_rgba(0,0,0,0.15)] hover:shadow-[0_8px_25px_rgba(0,96,57,0.55),inset_0_2px_0_rgba(255,255,255,0.3),inset_0_-2px_4px_rgba(0,0,0,0.15)] hover:from-[#00a066] hover:via-[#006d40] hover:to-[#004a2c] rounded-full transition-all active:shadow-[0_2px_8px_rgba(0,96,57,0.3),inset_0_3px_6px_rgba(0,0,0,0.2)] border border-[#004d2e]/30",
      },
      size: {
        default: "h-11 px-6 py-2",
        sm: "h-9 rounded-md px-4 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        xl: "h-14 rounded-xl px-10 text-lg",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }